<template>
  <modal name="delete-modal"
         @before-open="handleBeforeOpen"
         style="z-index: 1001;">
    <div id="modal-header" class="w-100 px-4 py-2 position-relative bg-danger-gradient">
      <div class="w-100 d-flex">
        <h4 class="text-white"></h4>
      </div>
      <button type="button"
              class="close position-absolute"
              style="right: 1.25rem; top: 30%"
              @click="$modal.hide('delete-modal')" aria-label="Close">
        <span aria-hidden="true" class="text-white">&times;</span>
      </button>
    </div>
    <div id="modal-body"
         class="d-flex justify-content-center align-items-center p-4"
         style="overflow-x: auto; height: 75%">
      <p class="h4">{{ alertMsg }}</p>
    </div>
    <div id="modal-footer" class="bg-white position-absolute w-100 p-3 text-right" style="bottom: 0">
      <button @click="$modal.hide('delete-modal')" class="btn btn-sm btn-light mr-3">
        {{ declineBtnText }}
      </button>
      <button @click="confirm" type="button" class="btn btn-sm btn-danger">
        {{ confirmBtnText }}
      </button>
    </div>
  </modal>
</template>

<script>
  export default {
    name: 'DeleteModal',
    props: {
      confirmBtnText: {
        default: 'Հաստատել',
        type:  String
      },
      declineBtnText: {
        default: 'Չեղարկել',
        type: String
      }
    },
    data() {
      return {
        alertMsg: '',
        callback: null,
      }
    },
    methods: {
      handleBeforeOpen({ params }) {
        this.alertMsg = params.msg
        this.callback = params.callback
      },
      confirm() {
        this.callback()
      }
    }
  }
</script>

<style scoped>
  /deep/ .vm--modal {
    top: 20% !important;
    left: unset !important;
    width: 30vw !important;
    height: 35vh !important;
    margin: auto;
    -webkit-border-radius: .3rem !important;
    -moz-border-radius: .3rem !important;
    border-radius: .3rem !important;
  }
</style>
